<template>
    <div class="vx-card p-6">
        <div class="vx-row mb-4">
            <div class="vx-col w-full">
                <h3>Chi tiết bài viết</h3>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col md:w-1/3">
                <div class="vx-row">
                    <div class="vx-col w-full mt-2">
                        <label class="vs-input--label">{{ this.$t('menuNewFeed.user') }}</label>
                        <vs-input class="w-full" v-model="dataInfo.fullName"
                                  :placeholder="$t('menuNewFeed.user')" disabled
                                  :disable="isUpdate" name="fullName">
                        </vs-input>
                        <span class="text-danger text-sm">{{ errors.first('user') }}</span>
                    </div>
                    <div class="vx-col w-full mt-2" v-if="isUpdate">
                        <label class="vs-input--label">{{ this.$t('menuNewFeed.createdDate') }}</label>
                        <flat-pickr :config="configDatePicker" v-model="dataInfo.createdDate"
                                    class="w-full vs-inputx vs-input--input normal"
                                    name="createdDate" disabled/>
                        <span class="text-danger text-sm">{{ errors.first('createdDate') }}</span>
                    </div>
                    <div class="vx-col lg:w-1/2 md:w-full w-1/2 mt-2">
                        <label class="vs-input--label">{{ this.$t('menuNewFeed.status') }}</label>
                        <v-select v-model="dataInfo.status" :options="statusOptions" :clearable="false"
                                  name="statusForNewsEvent" :reduce="item => item.value"
                                  disabled>
                        </v-select>
                    </div>
                    <div class="vx-col lg:w-1/2 md:w-full w-1/2 mt-2">
                        <label class="vs-input--label">{{ this.$t('menuNewFeed.type') }}</label>
                        <v-select v-model="dataInfo.type" :options="typeOptions" :clearable="false"
                                  name="typeForNewsEvent" :reduce="item => item.value" :disabled="isUpdate">
                        </v-select>
                    </div>
                    <div class="vx-col w-full mt-3" v-if="dataInfo.status === 2">
                        <div class="vx-row">
                            <div class="vx-col w-1/2">
                                <p><b>Số lượt yêu thích: </b><b class="text-primary">{{ dataInfo.interactionCount }}</b>
                                </p>
                            </div>
                            <div class="vx-col w-1/2">
                                <p><b>Số lượt bình luận: </b><b class="text-primary">{{ dataInfo.commentCount }}</b></p>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col w-full mt-3" v-if="dataInfo.status === 3">
                        <label class="vs-input--label"> Lý do từ chối: </label>
                        <vs-textarea class="w-full" v-model="dataInfo.rejectReason"></vs-textarea>
                    </div>
                </div>
            </div>
            <!--Images-->
            <div class="vx-col md:w-1/3 w-full text-center md:mt-0 mt-4">
                <label class="vs-input--label">Ảnh bài viết</label>
                <div class="flex justify-center">
                    <vue-upload-multiple-image class="m-auto ml-auto" @upload-success="uploadImageSuccess"
                                               @before-remove="beforeRemove" @data-change="dataChange"
                                               :data-images="images">
                    </vue-upload-multiple-image>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full text-center md:mt-0 mt-4">
                <label class="vs-input--label">Video bài viết</label>
                <div class="flex justify-center">
                    <vue-upload-multiple-media class="" @upload-success="uploadVideoSuccess"
                                               @before-remove="beforeRemoveVideo" @data-change="dataChangeVideo"
                                               :data-videos="videos">
                    </vue-upload-multiple-media>
                </div>
                <canvas ref="canvas" style="display: none;"></canvas>
            </div>
        </div>

        <!--contentPost-->
        <div class="vx-row mt-2 content_details">
            <div class="vx-col w-full mt-4 quill-editor">
                <label class="vs-input--label">{{ this.$t('menuNewsEvent.contentPost') }}</label>
                <vs-textarea v-model="dataInfo.content" class="" :disabled="userInfo.fullName !== dataInfo.fullName"/>
            </div>
        </div>

        <!--buttons-->
        <div class="vx-row mt-8">
            <div class="vx-col w-full ">
                <div class="flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mr-4" color="success" v-if="isUpdate && dataInfo.status === 1" @click="btnApproved">
                        {{ $t('button.approved') }}
                    </vs-button>
                    <vs-button :class="{'ml-auto': dataInfo.status !== 1}" @click="saveInfoNewEvent" v-if="showBtn()">
                        {{ `${isUpdate ? $t('button.update') : $t('button.create')}` }}
                    </vs-button>
                    <vs-button class="ml-4" type="border" color="warning" onclick="history.back()">
                        {{ $t('button.back') }}
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import 'quill/dist/quill.snow.css';
import VueUploadMultipleImage from '../../../../components/VueUploadMultipleImage';
import VueUploadMultipleMedia from '../../../../components/VueUploadMultipleMedia';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Vietnamese} from 'flatpickr/dist/l10n/vn';

export default {
    name: "PostsInfo",
    components: {
        vSelect,
        Datepicker,
        moment,
        VueUploadMultipleImage,
        VueUploadMultipleMedia,
        flatPickr,
    },
    data() {
        return {
            isUpdate: false,
            images: [],
            videos: [],
            dataInfo: {
                fullName: null,
                content: '',
                id: null,
                status: null,
                createdDate: new Date(),
                type: null,
            },
            statusOptions: [
                {value: 1, label: 'Chờ duyệt'},
                {value: 2, label: 'Đã duyệt'},
                {value: 3, label: 'Từ chối'},
            ],
            fileListData: [],
            configDatePicker: {
                dateFormat: 'Z',
                // defaultDate: new Date(),
                locale: Vietnamese,
                maxDate: new Date(),
                altFormat: 'd/m/Y H:i',
                altInput: true,
                wrap: true,
                allowInput: true,
                // time_24hr: true,
            },
            thumbnailData: [],
            mapVideoThumbnail: [],
            resUpload: [],
            typeOptions: [
                {value: 1, label: 'Bài viết'},
                {value: 2, label: 'Tin'},
            ],
            userInfo: null,
            removeIds: [],
            isUpdateImages: false,
            isUpdateVideos: false,
            imagesUpdate: [],
            videosUpdate: [],
        }
    },
    created() {

        let check = false;
        this.$eventBus.$on("notify-detail-posts", ($event) => {
            if ($event) this.initScreen();
            check = true;
        })
        if (!check) this.initScreen();
    },
    computed: {
        selectStatus: {
            get() {
                let obj = this.statusOptions.find(x => x.value === this.dataInfo.status);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.dataInfo.status = obj ? obj.value : null;
            }
        },
    },
    methods: {
        async initScreen() {
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
            if (!this.isUpdate) {
                this.dataInfo.fullName = this.userInfo.fullName;
                this.dataInfo.status = 1;
                this.dataInfo.type = 1;
            }
            if (this.$route.query.id) {
                this.isUpdate = true;
                await this.findServiceById(this.$route.query.id);
                for (const x of this.dataInfo.fileManagers) {
                    let data = await this.toDataURL(x.url);
                    let dataImage = data.xhr.response;
                    if (x.fileManagerType === 1 || x.fileManagerType === 5) {
                        let metadata = {
                            type: dataImage.type
                        };
                        let file = new File([dataImage], x.fileName, metadata);
                        this.images.push({
                            name: x.fileName,
                            path: data.mediaBase64,
                            highlight: 1,
                            default: 1,
                            file: file,
                            id: x.id,
                        });
                    }
                    if (x.fileManagerType === 2 || x.fileManagerType === 6) {
                        let metadata = {
                            type: dataImage.type
                        };
                        let file = new File([dataImage], x.fileName, metadata);
                        this.videos.push({
                            name: x.fileName,
                            path: data.mediaBase64,
                            highlight: 1,
                            default: 1,
                            file: file,
                            id: x.id,
                        });
                    }
                }
            }
        },

        async saveInfoNewEvent() {
            if (this.dataInfo.type === 2) {
                if (this.images.length > 0 || this.videos.length !== 1) {
                    return this.$vs.notify({
                        text: 'Tin chỉ được đăng duy nhất 1 video',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            }
            if (!this.dataInfo.content && this.images.length === 0 && this.videos.length === 0) {
                return this.$vs.notify({
                    text: 'Bài viết bắt buộc phải có nội dung hoặc ảnh/video',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
            if (!this.isUpdate || (this.isUpdate & (this.isUpdateImages || this.isUpdateVideos))) await this.uploadFiles();

            let url = this.isUpdate ? `/beauty-news-feed/update?removeIds=${this.removeIds}` : `/beauty-news-feed/create`;
            // if ((this.isUpdateImages || this.isUpdateVideos) && this.removeIds.length > 0) {
            //     url = url + `?removeIds=${this.removeIds}`
            // }
            let payload = {
                beautyUploads: this.resUpload,
                content: this.dataInfo.content.replace(/<\/?p>/g, ''),
                status: this.dataInfo.status,
                id: this.isUpdate ? this.$route.query.id : null,
                type: this.dataInfo.type,
            }
            // Goi API
            this.$vs.loading();
            this.$crm.post(url, payload).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? 'Cập nhật bài viết thành công!' : 'Tạo mới thành công bài viết!'}`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                });
                this.$vs.loading.close();
                setTimeout(() => {
                    this.$router.push('/user/posts-waiting-for-approval');
                }, 500)
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        findServiceById(id) {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get(`/beauty-news-feed/find-by-id/${id}`).then(res => {
                    this.dataInfo = res.data;
                    if (this.dataInfo.liked) this.dataInfo.interactionCount = this.dataInfo.interactionCount + 1;
                    resolve()
                    this.$vs.loading.close();
                }).catch(err => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        //Images
        async uploadImageSuccess(formData, index, fileList,) {
            this.images = fileList;
            if (this.isUpdate) this.imagesUpdate = this.images.filter(el => !el.id);
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.removeIds.push(fileList[index].id);
            this.setIsUpdateImages();
            done();
            this.images = fileList;
        },

        dataChange() {
            // this.images = fileList;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },

        //Video
        async uploadVideoSuccess(formData, index, fileList,) {
            this.videos = fileList;
            if (this.isUpdate) this.videosUpdate = this.videos.filter(el => !el.id);
            this.setIsUpdateVideos();
        },
        async beforeRemoveVideo(index, done, fileList) {
            this.removeIds.push(fileList[index].id);
            this.setIsUpdateVideos();
            done();
            this.videos = fileList;
        },

        dataChangeVideo() {
            // this.images = fileList;
            this.setIsUpdateVideos();
        },

        setIsUpdateVideos() {
            if (this.isUpdate) {
                this.isUpdateVideos = true;
            }
        },

        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({mediaBase64: reader.result, xhr: xhr});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },

        uploadFiles() {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                if (!this.isUpdate) {
                    this.images.forEach(x => formData.append('images', x.file));
                    this.videos.forEach(x => formData.append('videos', x.file));
                }
                if (this.isUpdateImages) this.imagesUpdate.forEach(x => formData.append('images', x.file));
                if (this.isUpdateVideos) this.videosUpdate.forEach(x => formData.append('videos', x.file));

                this.$vs.loading();
                this.$crm.post('/beauty-news-feed/upload-file', formData).then(res => {
                    this.resUpload = res.data;
                    resolve(res);
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        showBtn() {
            if (!this.isUpdate) return true;
            if (this.isUpdate) {
                if (this.userInfo.fullName === this.dataInfo.fullName) return true;
                // if (this.userInfo.fullName === this.dataInfo.fullName && this.dataInfo.status === 1) return true;
                if (this.userInfo.userRole === 'organization') return true
            }
            return false;
        },

        btnApproved() {
            this.$vs.loading();
            this.$crm.post(`/beauty-news-feed/change-status/${this.dataInfo.id}`, {status: 2}).then(() => {
                this.$vs.notify({
                    text: 'Duyệt bài viết thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.$vs.loading.close();
                this.$router.push('/user/posts-waiting-for-approval');
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        }
    },
}
</script>

<style lang="scss">
.content_details {
    .vs-textarea {
        height: 350px !important;
    }
}
</style>
